import React, { useState, Component } from 'react';
import {toggleTheme, ThemeType } from '@scuf/common';
const UseIconCompany = ({callback}) => {

    const [selected, setState] = useState({isDark: true, logoCompany: '../assets/codelco_logo.png'});
     

    const changeLogo = () => {
        if (selected.isDark) {
          toggleTheme(ThemeType.Dark);
          setState({
            logoCompany: '../assets/codelco_logo.png',
            isDark: false
          })
        } else {

            toggleTheme(ThemeType.Light);
            setState({
              logoCompany: '../assets/codelco_logo.png',
              isDark: true
            })
        }
        localStorage.setItem('isDark', selected.isDark);

    }

    return (<div
        onClick={()=> changeLogo()}
        style={{
          cursor:'pointer',
          fontSize:'20px',
          textAlign:'center',
          marginLeft:'20px'
        }}> 
          <i className={selected.isDark == true ? 'fas fa-sun' : 'fas fa-moon'}></i>
        
        </div>)
}

export default UseIconCompany;